import PubSub from 'pubsub-js';
import type { ViewResolvedParam } from '../types';

export const VIEW_RESOLVED_EVENT_ID = Symbol('7T:View.Resolved');

export const viewResolvedEventPubSub:
PubSubJS.Base<ViewResolvedParam, typeof VIEW_RESOLVED_EVENT_ID> = PubSub;
